<markant-platform-modal-bridge>
  <markant-dialog
    class="cancel-process-dialog"
    critical="true"
    [open]="true"
    (close)="closed.emit()"
  >
    <h2 class="header">
      {{ 'cartridge.management.cancelProcess.title' | transloco }}
    </h2>
    <div class="content">
      {{ 'cartridge.management.cancelProcess.prologue' | transloco }}
      <ol>
        <li>
          {{ 'cartridge.management.cancelProcess.firstStep' | transloco }}
        </li>
        <br />
        <li
          [innerHTML]="
            'cartridge.management.cancelProcess.secondStep' | transloco
          "
        ></li>
      </ol>
      {{ 'cartridge.management.cancelProcess.inAddition' | transloco }}
    </div>
    <div slot="footer">
      <markant-button
        colorScheme="primary"
        data-markant-dialog-action="submit"
        (click)="sendCancellationRequest()"
      >
        {{ 'general.close' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
